/**
 * Created by mauget on 2/3/16.
 */

// SmallTextControlView

import eventBus         from 'EventBus';
import BaseControlView from 'BaseControlView';
import contentTemplate from 'common-visuals/control-small-text.ejs';
import constants        from "Constants";
//=====================================================================
//
// An instance of this view represents a Small Text control.
//
// Lou Mauget, February 3, 2016
//
//=====================================================================
class SmallTextControlView extends BaseControlView  {

    initialize( opts ) {
        super.initialize( opts );

        this.template = contentTemplate;
        this.tagName = 'div';
        this.propViews = opts.propViews;

        this.listenTo(this.model, 'change', this.render);
        this.listenTo( eventBus, 'smallTextThemeChange', this.themeChangeRender);
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
        return this;
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'BaseStaticTextControl';
    }

}

export default SmallTextControlView;

